<script setup lang="ts">
import { useCompanyStore } from '@booking/stores/company'
import { CategoriesCompanyEnum } from '@types'
import { until } from '@vueuse/core'
import { storeToRefs } from 'pinia'

const store = useCompanyStore()
const { company } = storeToRefs(store)

const landingUrl = computed(() => {
  const isRu = true
  const domain = `https://cue-to.${isRu ? 'ru' : 'com'}`
  const path =
    company.value.meta?.category === CategoriesCompanyEnum.photoStudio && isRu ? '/industry/photo-studios' : ''
  const query = `?utm_source=label&utm_medium=organic&utm_campaign=${company.value.idAlias || 'all'}`
  return domain + path + query
})

useAsyncData(() => until(company).toMatch(v => !!v.id, { timeout: 10000 }))
</script>

<template lang="pug">
NuxtLink.shield.flex-center-baseline.row-6.typ-14-20-300.m-t-auto(:to="landingUrl" target="_blank")
  | {{ $t('block.logo-shield.base.caption') }}
  span.typ-20-24-400 Cue
</template>

<style scoped>
.shield {
  color: var(--cue-content-neutral-disabled);
  text-decoration: none;
}
</style>
